// extracted by mini-css-extract-plugin
module.exports = {"subtotal":"subtotal_subtotal__1eGq-","heading":"subtotal_heading__3QWUa"};